"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContext = void 0;
const react_1 = require("react");
exports.DialogContext = react_1.createContext({
    handleId: '',
});
//# sourceMappingURL=dialog-context.js.map